import angular from 'angular';

import dashboardConfig from './dashboard.config';

import accountController from './controllers/accountController';

import accessSavingsDirective from './directives/accessSavings';
import dashboardTabsDirective from './directives/dashboardTabs';
import dashNavBarDirective from './directives/dashNavBar';
import myCauseCardDirective from './directives/myCauseCard';
import savingsCardDirective from './directives/savingsCard';
import accountNavDirective from './directives/accountNav';
import dashFooterDirective from './directives/dashFooter';
import entryPopupDirective from './directives/entryPopup';
import navbarDropdownDirective from './directives/navbarDropdown';
import savingsStatusCardDirective from './directives/savingsStatusCard';

const dashboardModule = angular.module('com.module.dashboard', []);

dashboardModule.config(dashboardConfig);

dashboardModule.controller('accountController', accountController);

dashboardModule.directive('accessSavings', accessSavingsDirective);
dashboardModule.directive('dashboardTabs', dashboardTabsDirective);
dashboardModule.directive('dashNavBar', dashNavBarDirective);
dashboardModule.directive('myCauseCard', myCauseCardDirective);
dashboardModule.directive('savingsCard', savingsCardDirective);
dashboardModule.component('accountNav', accountNavDirective);
dashboardModule.directive('dashFooter', dashFooterDirective);
dashboardModule.directive('entryPopup', entryPopupDirective);
dashboardModule.directive('navbarDropdown', navbarDropdownDirective);
dashboardModule.directive('savingsStatusCard', savingsStatusCardDirective);

export default dashboardModule;



// WEBPACK FOOTER //
// ./js/containers/dashboard/index.js